import React from "react";
import { FilterBar, Menu, Select, Switch } from "@sscs/ui";
import { getClassName } from "@sscs/utils";
import { ASSESSMENT_CATEGORY_ORDER, ASSESSMENT_TYPE_TO_TITLE, categoryToTitle, } from "../../../constants";
import { initFilter, selectFilteredByLink } from "../../../store/policiesSlice";
import { useCategoryFilterOptions, useReportSelector } from "../../hooks";
import { isFilteredByLink } from "../../utils";
import styles from "./filter.module.scss";
const getHighlightedStyles = (filter, key, filteredByLink) => {
    return getClassName({
        [styles.highlight]: isFilteredByLink(filter, initFilter, key, filteredByLink),
    });
};
const Filter = ({ filter, onChange }) => {
    const categoryFilterOptions = useCategoryFilterOptions();
    const filteredByLink = useReportSelector(selectFilteredByLink);
    return (React.createElement(FilterBar, { filters: [
            {
                id: "policy-category",
                width: "250px",
                control: (React.createElement(Select, { label: "Filter by policy category", id: "policies-policy-category-filter", labelId: "policy-category-filter-label", displayEmpty: true, shrinkLabel: true, value: filter.policy_category, onChange: (value) => onChange({
                        ...filter,
                        policy_category: value,
                    }), className: getHighlightedStyles(filter, "policy_category", filteredByLink) },
                    React.createElement(Menu.Item, { id: "show-all-policies", value: "ALL" }, "Show all policies"),
                    categoryFilterOptions.map((category) => (React.createElement(Menu.Item, { id: `filtered-by-${category}`, key: category, value: category }, categoryToTitle[category]))))),
            },
            {
                id: "assessment-category",
                width: "250px",
                control: (React.createElement(Select, { label: "Filter by assessment category", id: "policies-assessment-category-filter", labelId: "assessment-category-filter-label", displayEmpty: true, shrinkLabel: true, value: filter.assessment_category, onChange: (value) => onChange({
                        ...filter,
                        assessment_category: value,
                    }), className: getHighlightedStyles(filter, "assessment_category", filteredByLink) },
                    React.createElement(Menu.Item, { id: "show-all-policies", value: "ALL" }, "Show all policies"),
                    ASSESSMENT_CATEGORY_ORDER.map((category) => (React.createElement(Menu.Item, { id: `filtered-by-${category}`, key: category, value: category }, ASSESSMENT_TYPE_TO_TITLE[category]))))),
            },
            {
                id: "policy-state",
                width: "250px",
                control: (React.createElement(Select, { label: "Filter by policy state", id: "policies-policy-state-filter", labelId: "policy-state-filter-label", displayEmpty: true, shrinkLabel: true, value: filter.policy_state, onChange: (value) => onChange({
                        ...filter,
                        policy_state: value,
                    }), className: getHighlightedStyles(filter, "policy_state", filteredByLink) },
                    React.createElement(Menu.Item, { id: "show-all-policies", value: "ALL" }, "Show all policies"),
                    React.createElement(Menu.Item, { id: "filtered-by-enabled", value: "enabled" }, "Enabled"),
                    React.createElement(Menu.Item, { id: "filtered-by-disabled", value: "disabled" }, "Disabled"),
                    React.createElement(Menu.Item, { id: "filtered-by-violated", value: "violated" }, "Violated"))),
            },
            {
                id: "is-audit-present-only",
                fit: true,
                control: (React.createElement(Switch, { title: "Filter policies", label: "With audit", checked: filter.is_audit_present_only, onChange: (event) => onChange({
                        ...filter,
                        is_audit_present_only: event.target.checked,
                    }), className: getHighlightedStyles(filter, "is_audit_present_only", filteredByLink) })),
            },
        ] }));
};
export default Filter;
//# sourceMappingURL=Filter.js.map